import { auth } from "@/config/firebase";
import { queryClient } from "@/config/query";
import storage from "@/utils/storage";
import { User, UserInfo } from "firebase/auth";
import { create } from "zustand";
import * as Sentry from "@sentry/react";

interface IntitialState {
    email: string | null;
    emailVerified: boolean;
    providerData: UserInfo[];
    authenticated: boolean;
    globalLoading: boolean;
    isAppLoaded: boolean;
}

interface Actions {
    login(): void;
    logout(): void;
    update(): Promise<void>;
    setGlobalLoading: (bool: boolean) => void;
    setIsAppLoaded: (loaded: boolean) => void;
}

const initialState: IntitialState = {
    email: null,
    emailVerified: false,
    providerData: [],
    authenticated: false,
    globalLoading: false,
    isAppLoaded: false,
};

export const useUser = create<IntitialState & Actions>(set => ({
    ...initialState,
    setGlobalLoading: globalLoading => set({ globalLoading }),
    setIsAppLoaded: (loaded: boolean) => set({ isAppLoaded: loaded }),
    login: () => {
        const user = auth.currentUser as User;

        const { email, emailVerified, uid, providerData } = user;
        set({ email, emailVerified, providerData, authenticated: true });

        storage.setItem("lastLogin", Date.now());
        Sentry.setUser({ id: uid, ...(email && { email }) });
    },
    logout: () => {
        set(state => ({ ...initialState, isAppLoaded: state.isAppLoaded }));

        storage.clear(), queryClient.clear(), sessionStorage.clear();
        Sentry.setUser(null);
    },
    update: async () => {
        const user = auth.currentUser as User;
        await user.reload();

        const { email, emailVerified, providerData } = user;

        set({ email, emailVerified, providerData });
    },
}));
